import { tags as en_tags } from "../en/tags";

/** tags — ru slice. */
export const tags: Record<keyof typeof en_tags, string> = {
  // --- Profile tags ---
  tag_90s_kid: "Дитя 90-х",
  tag_restaurants: "Рестораны",
  tag_music: "Музыка",
  tag_self_care: "Забота о себе",
  tag_concerts: "Концерты",
  tag_house_parties: "Домашние вечеринки",
  tag_drinks: "Напитки",
  tag_athletics: "Лёгкая атлетика",
  tag_religious: "Религия",
  tag_sports: "Спорт",
  tag_meditation: "Медитация",
  tag_night_life: "Ночная жизнь",
  tag_books: "Книги",
  tag_cafes: "Кафе",
  tag_raves: "Рейвы",
  tag_clubs: "Клубы",
  tag_traveling: "Путешествия",
  tag_business: "Бизнес",
  tag_sneakers: "Кроссовки",
  tag_instagram: "Instagram",
  tag_nature: "Природа",
  tag_introvert: "Интроверт",
  tag_extrovert: "Экстраверт",
  tag_minimalist: "Минималист",
  tag_astrology: "Астрология",
  tag_fashion: "Мода",
  tag_tattoos: "Татуировки",
  tag_thrifting: "Секонд-хенд",
  tag_plant_parent: "Любитель растений",
  tag_dog_lover: "Любитель собак",
  tag_cat_lover: "Любитель кошек",
  tag_volunteering: "Волонтёрство",
  tag_sustainability: "Экологичность",
  tag_skincare: "Уход за кожей",
  tag_journaling: "Ведение дневника",
  tag_spirituality: "Духовность",
  tag_vintage: "Винтаж",
  tag_diy: "Сделай сам",
  tag_entrepreneurship: "Предпринимательство",
  tag_side_hustles: "Подработка",
  tag_cooking: "Готовка",
  tag_baking: "Выпечка",
  tag_coffee: "Кофе",
  tag_wine: "Вино",
  tag_craft_beer: "Крафтовое пиво",
  tag_cocktails: "Коктейли",
  tag_vegan: "Веган",
  tag_foodie: "Гурман",
  tag_brunch: "Бранч",
  tag_street_food: "Уличная еда",
  tag_sushi: "Суши",
  tag_bbq: "Барбекю",
  tag_tea: "Чай",
  tag_photography: "Фотография",
  tag_art: "Искусство",
  tag_museums: "Музеи",
  tag_theater: "Театр",
  tag_poetry: "Поэзия",
  tag_film: "Кино",
  tag_anime: "Аниме",
  tag_k_pop: "K-Pop",
  tag_hip_hop: "Хип-хоп",
  tag_jazz: "Джаз",
  tag_edm: "EDM",
  tag_r_b: "R&B",
  tag_podcasts: "Подкасты",
  tag_stand_up_comedy: "Стендап",
  tag_dancing: "Танцы",
  tag_writing: "Писательство",
  tag_design: "Дизайн",
  tag_gym: "Спортзал",
  tag_yoga: "Йога",
  tag_running: "Бег",
  tag_hiking: "Хайкинг",
  tag_swimming: "Плавание",
  tag_cycling: "Велоспорт",
  tag_climbing: "Скалолазание",
  tag_surfing: "Сёрфинг",
  tag_skiing: "Лыжи",
  tag_camping: "Кемпинг",
  tag_crossfit: "Кроссфит",
  tag_martial_arts: "Единоборства",
  tag_tennis: "Теннис",
  tag_basketball: "Баскетбол",
  tag_soccer: "Футбол",
  tag_skateboarding: "Скейтбординг",
  tag_tech: "Технологии",
  tag_gaming: "Игры",
  tag_coding: "Программирование",
  tag_startups: "Стартапы",
  tag_investing: "Инвестиции",
  tag_crypto: "Криптовалюта",
  tag_ai: "ИИ",
  tag_science: "Наука",
  tag_languages: "Языки",
  tag_psychology: "Психология",
  tag_philosophy: "Философия",
  tag_history: "История",
  tag_board_games: "Настольные игры",
  tag_trivia: "Викторины",
  tag_karaoke: "Караоке",
  tag_road_trips: "Путешествия на авто",
  tag_festivals: "Фестивали",
  tag_picnics: "Пикники",
  tag_beach: "Пляж",
  tag_netflix: "Netflix",
  tag_true_crime: "Тру-крайм",
  tag_memes: "Мемы",
  tag_tiktok: "TikTok",
  tag_youtube: "YouTube",

  // --- Company-only tags ---
  tag_food: "Еда",
  tag_concert: "Концерт",
  tag_outdoor_events: "Мероприятия на открытом воздухе",
  tag_tour: "Тур",
  tag_lounge: "Лаундж",
  tag_day_night_club: "Дневной/ночной клуб",
  tag_sporting_event: "Спортивное мероприятие",
  tag_social_club: "Клуб по интересам",
  tag_sports_exercise: "Спорт / Тренировки",
  tag_bar: "Бар",
  tag_nightclub: "Ночной клуб",
  tag_cafe: "Кафе",
  tag_brewery: "Пивоварня",
  tag_winery: "Винодельня",
  tag_event_space: "Пространство для мероприятий",
  tag_entertainment_venue: "Развлекательное заведение",
  tag_other: "Другое",
  // --- Interest category section headers (#49) ---
  tag_category_popular: "Популярное",
  tag_category_lifestyle: "Образ жизни и характер",
  tag_category_food_drink: "Еда и напитки",
  tag_category_arts_culture: "Искусство и культура",
  tag_category_fitness_outdoors: "Спорт и активности",
  tag_category_tech_learning: "Технологии и знания",
  tag_category_social_entertainment: "Общение и развлечения",
  tag_category_other: "Ещё",
};
